import * as React from 'react';
import './rank5.scss';
import { WebAnchorItemDesc, None, NewPagination, WithPage } from '@huyafed/comp';
// import MotorcadeDetail from './motorcadeDetail';
import { fetch, AreaInfo, RankItem, ContributeItem } from '@pubts/fetch.ts';

const { useEffect, useState, useMemo } = React;
interface Props {
  data: ContributeItem[],
}

const style = {
  color: '#7dc6ff',
  selectColor: 'black',
  background: '#42adff',
  selectBackground: '#ffd373',
};

const TeamRank: React.FC<Props> = props => (
  <div
    className={`web-FiveRank`}
  >
    <WebAnchorItemDesc
      width={970}
      color='#f6d94a'
      descs={['排名', '车队名称', `核心成员`, `守护主播`, `总里程`]} />
    <ul className='team-List'>
      {props.data.length === 0 ?
        <None text={'暂无车队数据'} color={'#fff'} />
        :
        props.data.map((items: ContributeItem, idx: number) => (
          <li key={Math.random()} className={`team-list` + idx}>
            <div className='rankNoCover'>
              <div className={`rank-${items.iRank <= 3 ? items.iRank : 'n'}`}>
                {items.iRank}
              </div>
            </div>
            <div className='groupName'>
              <div className='rank-6-flag'>
                {
                  items.sFlagName.split('').map((item: any, idx: number) => (
                    <p key={idx}>{item}</p>
                  ))
                }
              </div>
              {items.sMotorcadeName}
              <p>
                {items.sNickName}
              </p>
            </div>

            <div className='groupMember'>
              <div className='singles'>
                {items.vMemberList.value.map((single: any, index: number) =>
                (
                  <div className='single' key={index}>
                    <img
                      title={single.sNickName}
                      src={single.sLogoUrl}
                      onError={(event: any): void => {
                        event.target.onerror = null;
                        event.target.src = 'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                      }}
                      onClick={(): void => {
                        window.open('https://m.huya.com/' + single.tJump.iRoomId, '_blank');
                      }} />
                    {index === 0 &&
                      <i
                        className='dz'
                      ></i>}
                  </div>
                ),
                )}
              </div>
            </div>
            <div className='tPersenter' onClick={(): void => {
              window.open('https://m.huya.com/' + items.tPersenter.tJump.iRoomId, '_blank');
            }}>
              {
                items.tPersenter.sNickName && (
                  <><img
                    title={items.tPersenter.sNickName}
                    src={items.tPersenter.sLogoUrl}
                    onError={(event: any): void => {
                      event.target.onerror = null;
                      event.target.src = 'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                    }}
                  />
                    {items.tPersenter.sNickName}</>
                )
              }
              {
                !items.tPersenter.sNickName &&
                <div className="non-persenter"></div>
              }

            </div>
            <div className='groupScore'>
              <h1>{items.lScore}</h1>
            </div>
          </li>
        ))}
    </ul>
    {props.children}
  </div>
)


export default WithPage(TeamRank);